import gql from "graphql-tag";

export const SEND_BUY_NOW_PAY_LATER_EVENT = gql`
  mutation requestBuyNowPayLater($invoiceId: ID!) {
    requestBuyNowPayLater(invoiceId: $invoiceId)
  }
`;
